import { action } from 'ts-action';

export const routerLocationChange = action('@@router/LOCATION_CHANGE');

export const toggleColorTheme = action('[app] toggle color theme');
